import { render, staticRenderFns } from "./Ordered.vue?vue&type=template&id=43b9305e&"
import script from "./Ordered.vue?vue&type=script&lang=js&"
export * from "./Ordered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports